import { useState } from 'react';
import { login } from '../services/api';

export default function Login({ onLogin }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const res = await login(email, password);
      if (res.access_token) {
        if (res.user && res.user.role !== 'admin') {
          setError('Access denied. Admin accounts only.');
          setLoading(false);
          return;
        }
        localStorage.setItem('admin_token', res.access_token);
        localStorage.setItem('admin_user', JSON.stringify(res.user));
        onLogin(res.user);
      } else {
        setError(res.detail || 'Login failed');
      }
    } catch (err) {
      setError(err.response?.data?.detail || 'Login failed. Is backend running?');
    }
    setLoading(false);
  };

  return (
    <div className="login-page">
      <div className="login-card">
        <div className="login-logo">
          <h1>🏠 HomeChamp</h1>
          <p>Admin Dashboard</p>
        </div>
        {error && <div className="error-msg">⚠️ {error}</div>}
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Email</label>
            <input type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="Enter your email" required />
          </div>
          <div className="form-group">
            <label>Password</label>
            <input type="password" value={password} onChange={e => setPassword(e.target.value)} placeholder="••••••••" required />
          </div>
          <button type="submit" className="btn-block" disabled={loading}>
            {loading ? 'Logging in...' : 'Login to Dashboard'}
          </button>
        </form>
      </div>
    </div>
  );
}
